// pages/FormViewerPage/components/CustomerInfoFields/WhatsappField.tsx — No. WhatsApp field
import React, { useState } from 'react';
import BootstrapWhatsappIcon from '../../../../components/icons/BootstrapWhatsappIcon';
import { validateWhatsappNumber } from '../../services/formViewerService/validation';
import type { CustomerInfoFieldsProps } from './types';
import { ms } from '../../../../locales/ms';

export const WhatsappField: React.FC<CustomerInfoFieldsProps> = ({ form, customerData, fieldErrors, onWhatsappChange }) => {
    if (!form.customerFields?.whatsapp?.visible) return null;
    const [touched, setTouched] = useState(false);
    const digitCount = customerData.whatsapp.replace(/\D/g, '').length;
    const liveInvalid = touched && !validateWhatsappNumber(customerData.whatsapp).isValid;
    const showError = fieldErrors.whatsapp || liveInvalid;
    return (
        <div>
            <div className="flex justify-between items-center mb-0.5">
                <label htmlFor="field-whatsapp" className="flex items-center text-sm font-medium text-slate-700 dark:text-slate-300">
                    <BootstrapWhatsappIcon className="w-4 h-4 mr-1.5 text-emerald-600 dark:text-emerald-400" />
                    {ms(form, m => m.whatsapp, 'No. WhatsApp')} {form.customerFields?.whatsapp?.required && <span className="text-red-500">*</span>}
                </label>
                {digitCount > 0 && (
                    <span className="text-xs text-slate-500 dark:text-slate-400">
                        {digitCount}/15 {ms(form, m => m.digits, 'digit')}
                    </span>
                )}
            </div>
            <input
                id="field-whatsapp"
                type="tel"
                value={customerData.whatsapp}
                onChange={e => onWhatsappChange(e.target.value.replace(/[^0-9]/g, ''))}
                onBlur={() => setTouched(true)}
                placeholder={ms(form, m => m.whatsappPlaceholder, '08123456789')}
                maxLength={15}
                className={`w-full p-2.5 rounded-lg bg-slate-100 dark:bg-slate-700 border-0 outline-none focus:ring-2 focus:ring-orange-500 transition-all ${
                    showError ? 'ring-2 ring-red-400 dark:ring-red-500' :
                    touched && digitCount > 0 && digitCount < 10 ? 'ring-2 ring-amber-400 dark:ring-amber-500' :
                    ''
                }`}
                required={form.customerFields?.whatsapp?.required}
            />
            {showError && (
                <p className="text-xs text-red-500 mt-0.5">{fieldErrors.whatsapp || ms(form, m => m.whatsappInvalid, 'Nomor WhatsApp tidak valid')}</p>
            )}
        </div>
    );
};
